import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import TextareaAutosize from "react-textarea-autosize";
import { dropdownAction, goodsFormAction } from "../../redux/rootReducer";
import { GOODS_FORM_INITIAL } from "../../redux/initialStateConstant";
import { updateGoodsSagaAction } from "../../redux/sagaActions";

const GoodsForm = () => {
    const dispatch = useDispatch();

    const establishmentList = useSelector(state => state.establishmentList);
    const goodsForm = useSelector(state => state.goodsForm);
    const groups = useSelector(state => state.groups);
    const dropdown = useSelector(state => state.dropdown);

    if (!goodsForm.open) return false;

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close"
                            onClick={ () => dispatch(goodsFormAction(GOODS_FORM_INITIAL)) }
                        />
                        <div className="form__title">{
                            goodsForm.id
                            ? `Настройки товара № ${ goodsForm.id }`
                            : 'Новый товар'
                        }</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Название товара</div>
                        <input type="text" className="input"
                            value={ goodsForm.name }
                            onInput={ event => dispatch(goodsFormAction({
                                ...goodsForm,
                                name: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Описание</div>
                        <TextareaAutosize
                            className="input input--textarea"
                            value={ goodsForm.description }
                            onInput={ event => dispatch(goodsFormAction({
                                ...goodsForm,
                                description: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Стоимость</div>
                        <input type="text" className="input"
                            value={ goodsForm.cost }
                            onInput={ event => dispatch(goodsFormAction({
                                ...goodsForm,
                                cost: event.target.value
                            })) }
                        />
                    </div>
                    {
                        groups.length
                            ?
                            <div className="form__field">
                                <div className="input__caption input__caption--required">Группа товаров</div>
                                <div className="dropdown">
                                    <div className="input input--tick"
                                         onClick={ () => dropdown === 'groups' ? dispatch(dropdownAction(null)) : dispatch(dropdownAction('groups')) }
                                    >{ goodsForm.group.name }</div>
                                    <div className={ `dropdown__items ${ dropdown === 'groups' ? 'dropdown__items--open' : false }` }>
                                        {
                                            groups.map(elem => {
                                                return (
                                                    <div className="dropdown__item" key={ elem.id }
                                                         onClick={ () => {
                                                             dispatch(goodsFormAction({
                                                                 ...goodsForm,
                                                                 group: elem
                                                             }));
                                                             dispatch(dropdownAction(null));
                                                         } }
                                                    >{ elem.name }</div>
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                            : false
                    }
                    <div className="form__field">
                        <div className="input__caption input__caption--required" style={{ marginBottom: '10px' }}>Для каких заведений</div>
                        {
                            establishmentList.map(elem => {
                                return (
                                    <div style={{ marginBottom: '10px' }} key={ elem.id }>
                                        <div className="checkbox__wrapper" onClick={ () => {
                                            // Старый массив с заведениями
                                            let est = [...goodsForm.establishments];
                                            // Ищем индекс выбранного элемента
                                            let findIndex = est.findIndex(el => el === elem.id);
                                            // Если в массиве есть выбранный элемент, удаляем его
                                            if (findIndex + 1) {
                                                est.splice(findIndex, 1);
                                            }
                                            else {
                                                est.push(elem.id);
                                            }

                                            dispatch(goodsFormAction({
                                                ...goodsForm,
                                                establishments: est
                                            }));

                                        } }>
                                            <div className={ `checkbox ${ goodsForm.establishments.includes(elem.id) ? 'checkbox--active' : '' }` }/>
                                            <div className="checkbox__caption">{ elem.name }</div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => dispatch(updateGoodsSagaAction({
                                id: goodsForm.id,
                                name: goodsForm.name,
                                description: goodsForm.description,
                                cost: goodsForm.cost,
                                group: goodsForm.group.id,
                                establishments: JSON.stringify(goodsForm.establishments)
                            })) }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GoodsForm;